import { Routes } from '@angular/router';

import { authGuard } from '../core/auth/auth.guard';
import { AccessDeniedComponent } from '../shared/components/system-pages/access-denied/access-denied.component';
import { PageNotFoundComponent } from '../shared/components/system-pages/page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/home',
  },
  { path: 'access-denied', component: AccessDeniedComponent, canActivate: [authGuard] },
  {
    path: 'auth',
    loadChildren: () => import('../features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadChildren: () =>
      import('../features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  },
  {
    path: 'applications',
    canActivate: [authGuard],
    loadChildren: () =>
      import('../features/applications/application.routes').then((m) => m.APPLICATION_ROUTES),
  },
  {
    path: 'administration',
    canActivate: [authGuard],
    loadChildren: () =>
      import('../features/administration/administration.routes').then(
        (m) => m.ADMINISTRATION_ROUTES,
      ),
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadChildren: () =>
      import('../features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
  },
  {
    path: 'nominees',
    canActivate: [authGuard],
    loadChildren: () => import('../features/nominees/nominees.routes').then((m) => m.NOMINEE_ROUTES),
  },
  { path: '**', component: PageNotFoundComponent },
];
